import { logInfo } from 'utils/logging';

type ErrorResponse = {
  error: string;
};

type SuccessResponse = {
  message: string;
};

const forgetPassword = async (
  email: string,
): Promise<Partial<ErrorResponse & SuccessResponse>> => {
  return await fetch('/api/v1/guests/forget_password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
    }),
  })
    .then((data) => data.json())
    .catch(() => logInfo('forgetPassword api error', true));
};

export default forgetPassword;
